import React, { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const SeoCopySection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$seoCopySection' });

  return (
    <section className="base-section seo-section">
      <div className="seo-copy tagline">
        <h2 className="banner-title colored">{t('seoTitle')}</h2>
        <p>{t('seoText')}</p>
      </div>
    </section>
  );
};

export default SeoCopySection;
